/** Class names and helpers shared by the three branch relationship tabs. */

export const inputCls = 'rounded border border-border bg-white px-2 py-1.5 text-sm';
export const btnPrimary =
  'rounded bg-orange px-3 py-1.5 text-sm font-semibold text-white hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-orange';
export const btnSecondary =
  'rounded border border-border bg-white px-2 py-1 text-xs font-semibold text-navy hover:bg-bg focus:outline-none focus-visible:ring-2 focus-visible:ring-navy';

export const keyOf = (...parts: Array<string | number>) => parts.join('|');
